import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

type SuccessCallbackType = (response: any) => void;
type ErrorCallbackType = () => void;

interface GoogleSignUpProps {
  onSuccess: SuccessCallbackType;
  onError: ErrorCallbackType;
}

// @ts-ignore
export const GoogleSignUp: React.FC<GoogleSignUpProps> = ({ onSuccess, onError }) => {
  const clientId = '157120409370-lcgnci0hffbl7rlabdvrmh03s6nkumeq.apps.googleusercontent.com';

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin onSuccess={onSuccess} onError={onError} />
    </GoogleOAuthProvider>
  );
};

export default GoogleSignUp;
